export const stepTitles = [
    'Erzähl uns etwas über dich',
    'Wann hast du Geburtstag?',
    'Was ist dein Geschlecht?',
    'Wen möchtest du kennenlernen?',
    'Wo suchst du?',
    'Fast geschafft!',
    'Lade ein Profilbild hoch!',
];
export const stepDescription = [
    'Verrate uns einfach deinen Namen.',
    'So können wir dich besser zuordnen.',
    'Damit andere dich leichter finden können.',
    'Wir nutzen diese Information, um dir die passenden Profile vorzuschlagen.',
    'Dein Standort hilft uns, dir relevante Matches in deiner Nähe zu zeigen.',
    'Nur noch ein paar Infos und du bist dabei.',
    'Bitte lade ein Profilbild hoch – mit Bild hast du garantiert bessere Chancen.',
];
